// @ts-nocheck
// Agent Portal (/cti2) — Dialer's WebRTC/Soft Phone/Mobile device switcher,
// split out of Dialer.tsx. Pure presentation; profile-switch logic
// (handleToggleProfile) stays in the parent since it owns the underlying
// login/logout side effects.
import React from 'react';

export default function DialerDeviceTabs({
  activeProfileType,
  configuredProfiles,
  pendingProfileType,
  parsedStatus,
  onToggleProfile,
  webrtcLoginBlocked = false,
  webrtcLoginBlockedMessage = '',
}) {
  return (
    <div className="dialer-device-tabs" role="group" aria-label="Telephony device">
      {[{ key: 'WEBRTC', label: 'WebRTC' }, { key: 'Soft Phone', label: 'Softphone' }, { key: 'Mobile', label: 'Mobile' }]
        // Was showing every device as a disabled tab even when the agent
        // has no such profile at all — now only the ones actually on the
        // agent's account render; "not configured" is no longer a reason
        // to see (and be confused by) a tab that could never work for them.
        .filter((d) => configuredProfiles.has(d.key))
        .map((d) => {
        const active = activeProfileType === d.key;
        const configured = configuredProfiles.has(d.key);
        const busy = pendingProfileType === d.key;
        const notWired = d.key === 'Soft Phone';
        const slowWebrtc = d.key === 'WEBRTC' && webrtcLoginBlocked && !active;
        const disabled = !configured || notWired || slowWebrtc || Boolean(pendingProfileType);
        const connected = active && parsedStatus?.success;
        return (
          <button
            key={d.key}
            type="button"
            onClick={() => onToggleProfile(d.key)}
            disabled={disabled}
            title={
              slowWebrtc
                ? webrtcLoginBlockedMessage
                : notWired
                ? `${d.label} login is not available yet`
                : !configured
                  ? `${d.label} is not configured on your account`
                  : active
                    // Was a hardcoded "Connecting" whenever not yet
                    // connected — including a genuine registration error
                    // (parsedStatus.success false for a real failure, not
                    // just "still in progress"), so a real error looked
                    // exactly like an ongoing connection attempt forever.
                    // parsedStatus.message already carries the real state
                    // ("Authenticating...", "Dialer is Disconnected", or
                    // the actual SIP failure reason).
                    ? `${d.label} - ${connected ? 'Connected' : (parsedStatus?.message || 'Connecting')}`
                    : `Click to log into ${d.label}`
            }
            className={`dialer-device-tab${active ? ' active' : ''}${!configured || notWired || slowWebrtc ? ' unavailable' : ''}`}
          >
            {busy ? (
              <span className="dialer-device-spin" />
            ) : (
              <>
                {active && (
                  <span
                    className={`mr-1.5 inline-block h-1.5 w-1.5 rounded-full ${connected ? 'bg-success-foreground' : 'animate-pulse bg-warning'}`}
                    aria-hidden
                  />
                )}
                {d.label}
              </>
            )}
          </button>
        );
      })}
    </div>
  );
}
